const footerNav = [
  {
    title: '内容分区',
    links: [
      { label: '按类型选片', href: '#explore' },
      { label: '热门推荐', href: '#hot' },
      { label: '豆瓣高分', href: '#douban' },
      { label: '口碑电影', href: '#word' },
    ],
  },
  {
    title: '更多方向',
    links: [
      { label: '必看电影', href: '#must' },
      { label: '多维度榜单', href: '#rank' },
      { label: '观影指南', href: '#guide' },
      { label: '回到顶部', href: '#top' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-800 text-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
            <div className="md:col-span-5">
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 text-primary-800">
                  <i className="ri-film-line text-lg" aria-hidden="true"></i>
                </span>
                <span className="font-heading font-bold text-lg text-background-50">神马电影网</span>
              </div>
              <p className="mt-4 text-sm text-background-200/90 leading-relaxed max-w-md">
                神马电影网围绕「什么电影好看」整理热门推荐、高分电影、豆瓣高分与口碑电影，
                用一页内容帮你更快决定今晚看什么。
              </p>
              <div className="mt-5 flex flex-wrap gap-1.5">
                {['热门推荐', '高分电影', '豆瓣高分', '口碑电影', '必看电影'].map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-md bg-background-50/10 text-background-100 text-xs"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            {footerNav.map((col) => (
              <nav key={col.title} className="md:col-span-3 lg:col-span-2" aria-label={col.title}>
                <h4 className="font-heading font-bold text-background-50 text-sm md:text-base">{col.title}</h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.href + link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-200/90 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}

            <div className="md:col-span-12 lg:col-span-3">
              <h4 className="font-heading font-bold text-background-50 text-sm md:text-base">内容说明</h4>
              <p className="mt-4 text-sm text-background-200/90 leading-relaxed">
                本站评分与榜单为公开口碑整理，仅作选片参考，可能与各平台实时数据存在出入；
                影片信息如有更新，以官方发布为准。
              </p>
            </div>
          </div>
        </div>

        <div className="w-full max-w-6xl mx-auto py-5 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70">© 2026 神马电影网 · 什么电影好看整理站</p>
          <p className="text-xs text-background-200/70">页面内容仅作观影参考，本站不提供影片播放服务</p>
        </div>
      </div>
    </footer>
  );
}